import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/useUserServicePatchHook";

const RiderListComponent = loadable(
  () => import("../../components/Rider/RiderList")
);

const RiderList = () => {
  const { mutateAsync: patchUser } = usePatchHook({ queryKey: ["driver"], navigateURL: null })

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value
    };
    const url = `${APIS.USER}${id}/`;
    const formData = payload
    try {
      await patchUser({ url, formData });

    } catch (e) {
      console.log(e)
    }
  }
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Rider</span>
      </div>
      <RiderListComponent handleIsActive={handleIsActive} />
    </>
  );
};



export default RiderList
